<table class="table table-responsive">
  <thead>
    <th *ngFor="let col of columns" [class.hasorder]="col.order"
      [class.active-order]="pageControl.orderField === col.slug" (click)="onClickOrderBy(col.slug, col.order)">
      {{ col.title }}
      <i class="material-icons" *ngIf="pageControl.orderField === col.slug">
        {{ pageControl.order === 'DESC' ? 'arrow_downward' : 'arrow_upward' }}
      </i>
    </th>
  </thead>
  <tbody>
    <tr *ngIf="loading">
      <td [attr.colspan]="columns.length">
        <div class="loader-bubble loader-bubble-primary d-block"></div>
      </td>
    </tr>
    <ng-container *ngIf="!loading">
      <tr *ngIf="!list?.length">
        <td [attr.colspan]="columns.length" class="text-center">
          <div>Nenhum resultado encontrado</div>
        </td>
      </tr>
      <tr class="hover" style="outline: none;" (click)="routeToProfile(l.id)" *ngFor="let l of list; let i = index">
        <td [vAlign]="'middle'">
          <div>{{l.name}}</div>
          <div class="small">{{l?.cpf | cpfPipe}}</div>
        </td>
        <td [vAlign]="'middle'">
          <div>{{l.area}}</div>
        </td>
        <td [vAlign]="'middle'">
          <div>{{l.specialtyName}}</div>
        </td>
        <td [vAlign]="'middle'">
          <div>{{l.documentType}}: {{l.document}}</div>
        </td>
        <td [vAlign]="'middle'" class="row">
          <button mat-icon-button (click)="routeToSchedule(l); $event.stopPropagation();" aria-label="Abrir calendário">
            <i class="fal fa-calendar-alt"></i>
          </button>
          <button mat-icon-button (click)="routeToProfile(l.id)" aria-label="Abrir perfil do especialista">
            <i class="fal fa-pen"></i>
          </button>
          <button mat-icon-button (click)="onDeleteClick.emit(l.id); $event.stopPropagation();" aria-label="Abrir perfil do especialista">
            <i class="fal fa-trash-alt"></i>
          </button>
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>
<mat-paginator [length]="pageControl.count" [pageIndex]="pageControl.page" [pageSizeOptions]="[10, 25, 50, 100]"
  [pageSize]="pageControl.limit" (page)="pageEvent($event)"></mat-paginator>
